export default __webpack_public_path__ + "static/IBMPlexSans-Thin-Latin1-343b12c772b600a49f75e1c2ab7bc60f.woff";